
export const emailValidator = {
    value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    message: "Email is not valid!",
}

export const slugNameValidator = {
    value: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    message: "Slug name does not contain special characters and spaces!",
}

export const passwordValidator = {
    value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
    message: "Password must contain (Uppercase, lowercase, number,special character)!",
}


export const avoidEmptyStringValidator = {
    value: /^(?!\s*$).+/,
    message: "Empty spaces are not allowed",
}

export function generateOnlyNumberRegex(maxNumber?: number): RegExp {
    // Constructing the regex pattern based on the provided maxNumber
    let regexString = ``;
    if (maxNumber !== undefined) {
        regexString = `^([0-9]|[1-9][0-9]|${maxNumber})$`;
    } else {
        regexString = `^[0-9]+$`;
    }
    return new RegExp(regexString)
}


export const only2DecimalNumber = {
    value: /^\d+(\.\d{0,2})?$/,
    message: "Enter valid number",
}


export const onlyPercentageValidation = {
    value: /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/,
    message: "Enter valid percentage",
}


export const dollarAmountValidation = {
    value: /^-?\d{1,3}(,\d{3})*(\.\d{1,2})?$/,
    message: "Enter Valid amount",
}

export const numberWithoutDecimal = {
    value: /^-?\d{1,99}(,\d{3})*$/,
    message: "Distance should be a number",
}


export const namePattern =/^[a-zA-Z]+$/ 
export const companyNamePattern =/^[a-zA-Z\s\W]+$/
export const phoneNumberPattern =/^\+1\s\d{3}\s\d{3}\s\d{4}$/
export const NON_DIGIT_REGEX = /[^\d]/g; // Matches any character that is not a digit
export const STARTS_WITH_OPTIONAL_1_REGEX = /^1?/; // Matches an optional "1" at the start of the string